import { render, staticRenderFns } from "./vat-field.vue?vue&type=template&id=9d6fa15e&scoped=true&"
import script from "./vat-field.vue?vue&type=script&lang=js&"
export * from "./vat-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6fa15e",
  null
  
)

export default component.exports